import { createContext } from "react";
import { iEnquiry } from "../interfaces/iEnquiry";
export const ChangeEnquiryPriorityContext = createContext((enquiries: Array<iEnquiry>) => {});
